import React, { useState } from 'react';
import { Phone, Mail, MapPin, User, Check, Instagram, Menu, X, Home, Camera, MessageSquare, PlayCircle, FileText, Download } from 'lucide-react';

// --- CONFIGURAÇÃO FÁCIL ---

const corretora = {
  nome: "Elisangela Barcellos Catarina",
  creci: "RJ 050224",
  telefone: "5522998479003", // APENAS NÚMEROS (DDI + DDD + Numero)
  email: "elisangelabarcelloscorretora@gmail.com",
  instagramLink: "https://www.instagram.com/elisangelabarcellos_mrv/",
  whatsappLink: "https://wa.me/5522998479003?text=Ol%C3%A1%2C%20vi%20seu%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20Marbelle!",
  fotoPerfil: "perfil.jpg",
  arquivoFolder: "folder_marbelle.pdf"
};

// Configuração dos Vídeos
const videos = [
  { 
    id: 1, 
    src: "video1.mp4", 
    titulo: "Apresentação do Empreendimento", 
    capa: "foto_fachada.jpg" 
  },
  { 
    id: 2, 
    src: "video2.mp4", 
    titulo: "Tour pelo Decorado", 
    capa: "foto_piscina.jpg" 
  }
];

// --- IMAGEM DA CAPA (HERO) ---
const imagemCapa = "foto_piscina.jpg"; 

// SUA LISTA DE IMAGENS
const imagens = [
  { src: "foto_piscina.jpg", alt: "Área de Lazer com Piscina" },
  { src: "foto_sacada.jpg", alt: "Sacada" },
  { src: "foto_salao_de_festas.jpg", alt: "Espaço Gourmet" },
  { src: "foto_churrasqueira.jpg", alt: "Salão de Festas" },
  { src: "foto_cozinha.jpg", alt: "Cozinha" },
  { src: "foto_quarto_infantil.jpg", alt: "Quarto infantil" },
  { src: "foto_quarto_casal.jpg", alt: "Quarto de Casal" },
  { src: "foto_sala.jpg", alt: "Sala de estar" },
  { src: "foto_area_externa.jpg", alt: "Área Externa" },
];

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Estados para o formulário
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    interesse: 'Quero comprar meu 1º imóvel'
  });

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // --- FUNÇÃO DO GOOGLE ADS ---
  // Função para avisar o Google Ads sobre o clique no WhatsApp
  const trackWhatsAppClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18020516026/_bPPCO_U5okcELqB7ZBD'
      });
    }
  };

  // Atualiza os dados conforme a pessoa digita
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  // Envia para o WhatsApp
  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Dispara a conversão no Google Ads
    trackWhatsAppClick();
    
    // Monta a mensagem SEM asteriscos
    const mensagem = `Olá Elisangela! Vim pelo site.%0A%0ANome: ${formData.nome}%0ATelefone: ${formData.telefone}%0AEmail: ${formData.email}%0AInteresse: ${formData.interesse}`;
    
    // Abre o WhatsApp
    const linkZap = `https://wa.me/${corretora.telefone}?text=${mensagem}`;
    window.open(linkZap, '_blank');
  };

  return (
    <div className="font-sans text-gray-800 bg-gray-50 min-h-screen flex flex-col">
      
      {/* --- Header / Navegação --- */}
      <nav className="bg-white shadow-md fixed w-full z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <div className="flex items-center">
              <div className="bg-green-600 text-white p-2 rounded-lg mr-3">
                <Home size={24} />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900 leading-tight">Elisangela Barcellos</h1>
                <p className="text-xs text-gray-500 font-medium tracking-wide">CRECI {corretora.creci}</p>
              </div>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6">
              <a href="#inicio" className="text-gray-600 hover:text-green-600 transition font-medium">Início</a>
              <a href="#sobre" className="text-gray-600 hover:text-green-600 transition font-medium">Sobre Mim</a>
              <a href="#videos" className="text-gray-600 hover:text-green-600 transition font-medium">Vídeos</a>
              <a href="#ficha" className="text-gray-600 hover:text-green-600 transition font-medium">Ficha Técnica</a>
              <a href="#galeria" className="text-gray-600 hover:text-green-600 transition font-medium">Fotos</a>
              
              {/* Ícones Sociais no Topo */}
              <div className="h-6 w-px bg-gray-300 mx-2"></div>
              
              <a 
                href={corretora.instagramLink} 
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-500 hover:text-pink-600 transition transform hover:scale-110"
                title="Instagram"
              >
                <Instagram size={22} />
              </a>
              <a 
                href={corretora.whatsappLink} 
                onClick={trackWhatsAppClick} // DISPARO AQUI
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-500 hover:text-green-600 transition transform hover:scale-110"
                title="WhatsApp"
              >
                <MessageSquare size={22} />
              </a>

              <a href="#contato" className="bg-green-600 text-white px-5 py-2 rounded-full hover:bg-green-700 transition font-bold shadow-lg transform hover:-translate-y-0.5 ml-2">
                Fale Comigo
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button onClick={toggleMenu} className="text-gray-600 hover:text-green-600 focus:outline-none">
                {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 animate-fade-in-down">
            <div className="px-4 pt-2 pb-6 space-y-2 shadow-lg">
              <a href="#inicio" onClick={toggleMenu} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-md">Início</a>
              <a href="#sobre" onClick={toggleMenu} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-md">Sobre Mim</a>
              <a href="#videos" onClick={toggleMenu} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-md">Vídeos</a>
              <a href="#ficha" onClick={toggleMenu} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-md">Ficha Técnica</a>
              <a href="#galeria" onClick={toggleMenu} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-md">Fotos</a>
              
              {/* Ícones Sociais Mobile */}
              <div className="flex items-center space-x-4 px-3 py-3 border-t border-gray-100 mt-2">
                 <a 
                  href={corretora.instagramLink} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="flex items-center text-gray-600 hover:text-pink-600 font-medium"
                >
                  <Instagram size={20} className="mr-2" /> Instagram
                </a>
                <a 
                  href={corretora.whatsappLink} 
                  onClick={trackWhatsAppClick} // DISPARO AQUI
                  target="_blank" 
                  rel="noreferrer" 
                  className="flex items-center text-gray-600 hover:text-green-600 font-medium"
                >
                  <MessageSquare size={20} className="mr-2" /> WhatsApp
                </a>
              </div>

              <a href="#contato" onClick={toggleMenu} className="block px-3 py-3 text-base font-bold text-green-600 bg-green-50 rounded-md mt-2">Entrar em Contato</a>
            </div>
          </div>
        )}
      </nav>

      {/* --- Hero Section (Capa) --- */}
      <section id="inicio" className="relative h-screen min-h-[600px] flex items-center justify-center pt-20">
        <div className="absolute inset-0 z-0">
          <img 
            src={imagemCapa} 
            alt="Capa do Site MRV Marbelle" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/60 to-gray-900/30"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="sm:w-2/3 lg:w-1/2">
            <span className="inline-block py-1 px-3 rounded-full bg-green-500/20 border border-green-400 text-green-300 text-sm font-bold mb-4 uppercase tracking-wider">
              Oportunidade em Macaé - RJ
            </span>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg">
              Seu Novo Lar no <span className="text-green-400">MRV Marbelle</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-100 mb-8 font-light max-w-lg drop-shadow-md border-l-4 border-green-500 pl-4 bg-black/10 backdrop-blur-sm rounded-r-lg py-2">
              Conforto, lazer completo e a segurança que sua família merece. Fale com quem entende do assunto.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href={corretora.whatsappLink} onClick={trackWhatsAppClick} target="_blank" rel="noreferrer" className="flex items-center justify-center bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition shadow-lg transform hover:-translate-y-1">
                <MessageSquare className="mr-2" size={20} />
                Chamar no WhatsApp
              </a>
              <a href="#videos" className="flex items-center justify-center bg-white/10 border border-white/30 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded-lg font-bold text-lg transition shadow-lg">
                <PlayCircle className="mr-2" size={20} />
                Ver Vídeos
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* --- Sobre a Corretora --- */}
      <section id="sobre" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="w-full md:w-1/2 relative">
               <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl bg-gray-200 relative">
                  <img 
                    src={corretora.fotoPerfil} 
                    alt="Elisangela Barcellos" 
                    className="w-full h-full object-cover z-10 relative"
                    onError={(e) => {
                      e.target.style.display = 'none'; 
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="absolute inset-0 hidden items-center justify-center bg-green-100 text-green-800 z-0">
                    <div className="text-center p-6">
                        <User size={64} className="mx-auto mb-4 opacity-50"/>
                        <p className="font-bold text-lg">Foto de Perfil</p>
                        <p className="text-sm opacity-75">Adicione 'perfil.jpg' na pasta public</p>
                    </div>
                  </div>
               </div>
               
               <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border border-gray-100 hidden md:block z-20">
                 <p className="text-sm text-gray-500 uppercase font-bold tracking-wider mb-1">CRECI</p>
                 <p className="text-2xl font-bold text-green-600">{corretora.creci}</p>
               </div>
            </div>
            
            <div className="w-full md:w-1/2">
              <h3 className="text-green-600 font-bold tracking-wider uppercase mb-2">Compromisso e Confiança</h3>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Olá, sou Elisangela Barcellos</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Especialista em realizar sonhos em Macaé e região. Como corretora credenciada, meu foco é ajudar você a encontrar o apartamento ideal no <strong>MRV Marbelle</strong> com as melhores condições de financiamento.
              </p>
              
              <ul className="space-y-4 mb-8">
                {[
                  "Consultoria completa para financiamento",
                  "Atendimento personalizado e transparente",
                  "Especialista em imóveis MRV na região",
                  "Acompanhamento do início ao fim do processo"
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <div className="bg-green-100 p-1 rounded-full mr-3 text-green-600">
                      <Check size={16} strokeWidth={3} />
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="flex flex-col sm:flex-row gap-4">
                 <a href={corretora.whatsappLink} onClick={trackWhatsAppClick} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center text-green-600 border-2 border-green-600 font-bold hover:bg-green-600 hover:text-white rounded-lg px-6 py-3 text-lg transition">
                    Converse comigo <span className="ml-2">→</span>
                 </a>
                 <a href={corretora.arquivoFolder} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center bg-gray-100 text-gray-700 font-bold hover:bg-gray-200 rounded-lg px-6 py-3 text-lg transition">
                    <Download size={20} className="mr-2" /> Baixar Folder
                 </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- VÍDEOS --- */}
      <section id="videos" className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-green-400 font-bold tracking-wider uppercase mb-2 block">Tour Virtual</span>
            <h2 className="text-3xl md:text-4xl font-bold">Conheça o Marbelle por dentro</h2>
            <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Assista aos vídeos e veja os detalhes do acabamento e da área de lazer.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            {videos.map((video) => (
              <div key={video.id} className="flex flex-col items-center">
                <div className="relative w-full max-w-[320px] aspect-[9/16] bg-black rounded-3xl shadow-2xl border-4 border-gray-700 overflow-hidden group">
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-800 -z-10">
                      <p className="text-gray-500 text-xs">Carregando vídeo...</p>
                  </div>
                  
                  <video 
                    controls 
                    className="w-full h-full object-cover"
                    poster={video.capa || imagens[0].src} 
                  >
                    <source src={video.src} type="video/mp4" />
                    Seu navegador não suporta vídeos.
                  </video>
                </div>
                <h3 className="mt-6 text-xl font-bold text-white">{video.titulo}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- NOVA SEÇÃO: FICHA TÉCNICA (Extraída do PDF) --- */}
      <section id="ficha" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
             <div className="text-center mb-16">
                <span className="text-green-600 font-bold tracking-wider uppercase mb-2 block">Detalhes do Empreendimento</span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Ficha Técnica Completa</h2>
                <p className="text-gray-500 mt-2">Todas as informações técnicas para você investir com segurança.</p>
             </div>

             <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                        <Home className="mr-2 text-green-600" /> O Empreendimento
                    </h3>
                    <ul className="space-y-4">
                        <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">Terreno Total</span>
                            <span className="font-bold text-gray-900">23.847,75 m²</span>
                        </li>
                        <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">Total de Unidades</span>
                            <span className="font-bold text-gray-900">448 Apartamentos</span>
                        </li>
                         <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">Blocos</span>
                            <span className="font-bold text-gray-900">28 Blocos</span>
                        </li>
                        <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">Vagas de Garagem</span>
                            <span className="font-bold text-gray-900">457 Vagas</span>
                        </li>
                        <li className="flex justify-between pt-2">
                            <span className="text-gray-600">Endereço</span>
                            <span className="font-bold text-gray-900 text-right w-1/2">Estrada Antônio Guimarães Mosqueira, s/n - Gleba Mato Escuro, Macaé/RJ</span>
                        </li>
                    </ul>
                </div>

                <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                        <Check className="mr-2 text-green-600" /> Tipologia e Lazer
                    </h3>
                    <ul className="space-y-4">
                        <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">2 Quartos c/ Varanda</span>
                            <span className="font-bold text-gray-900">45,20 m²</span>
                        </li>
                        <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">2 Quartos</span>
                            <span className="font-bold text-gray-900">40,83 m²</span>
                        </li>
                         <li className="flex justify-between border-b border-gray-200 pb-2">
                            <span className="text-gray-600">Área Privativa</span>
                            <span className="font-bold text-gray-900">9,90m² a 33,39m²</span>
                        </li>
                        <li className="mt-4">
                            <span className="text-gray-600 block mb-2 font-bold">Itens de Lazer:</span>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                Salão de festas, Espaço Gourmet, Playground, Piscinas Adulto e Infantil, Pet Place, Miniquadra, Fitness Descoberto e Gazebo.
                            </p>
                        </li>
                    </ul>
                </div>
             </div>
             
             {/* Box de Download do PDF */}
             <div className="bg-green-600 rounded-2xl p-8 text-white flex flex-col md:flex-row items-center justify-between shadow-xl">
                <div className="mb-6 md:mb-0">
                    <h3 className="text-2xl font-bold mb-2 flex items-center">
                        <FileText className="mr-3" /> Baixe a Apresentação Completa
                    </h3>
                    <p className="text-green-100 max-w-xl">
                        Tenha acesso a todas as plantas detalhadas, localização exata e memorial descritivo baixando o folder oficial em PDF.
                    </p>
                </div>
                <a 
                    href={corretora.arquivoFolder} 
                    target="_blank" 
                    rel="noreferrer"
                    className="bg-white text-green-700 hover:bg-green-50 font-bold py-4 px-8 rounded-lg shadow-md transition transform hover:-translate-y-1 flex items-center"
                >
                    <Download className="mr-2" size={20} /> Baixar PDF
                </a>
             </div>
          </div>
      </section>

      {/* --- Diferenciais --- */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-12 text-gray-900">Diferenciais da Região</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="p-6 bg-white rounded-xl border border-gray-100 hover:shadow-lg transition duration-300">
                    <div className="w-14 h-14 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                        <Camera size={28} />
                    </div>
                    <h3 className="text-xl font-bold mb-2 text-gray-900">Lazer Completo</h3>
                    <p className="text-gray-600">Piscina, churrasqueira e playground para aproveitar os melhores momentos.</p>
                </div>
                <div className="p-6 bg-white rounded-xl border border-gray-100 hover:shadow-lg transition duration-300">
                    <div className="w-14 h-14 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                        <MapPin size={28} />
                    </div>
                    <h3 className="text-xl font-bold mb-2 text-gray-900">Localização</h3>
                    <p className="text-gray-600">Próximo ao futuro Porto Tepor, Aeroporto e Praia do Barreto. Região em alta valorização.</p>
                </div>
                <div className="p-6 bg-white rounded-xl border border-gray-100 hover:shadow-lg transition duration-300">
                    <div className="w-14 h-14 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                        <Home size={28} />
                    </div>
                    <h3 className="text-xl font-bold mb-2 text-gray-900">Segurança</h3>
                    <p className="text-gray-600">Apartamentos com design moderno e segurança de condomínio fechado.</p>
                </div>
            </div>
        </div>
      </section>

      {/* --- Galeria de Fotos --- */}
      <section id="galeria" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Galeria de Fotos</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Veja as fotos reais das áreas comuns, piscina e estrutura que preparamos para você.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {imagens.map((img, index) => (
              <div key={index} className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer h-64">
                <img 
                  src={img.src} 
                  alt={img.alt} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <p className="text-white font-medium p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    {img.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
             <p className="text-gray-500 italic mb-4">Tem mais fotos disponíveis! Solicite o álbum completo no WhatsApp.</p>
             <a href={corretora.whatsappLink} onClick={trackWhatsAppClick} className="inline-block border-2 border-green-600 text-green-600 font-bold py-2 px-6 rounded-full hover:bg-green-600 hover:text-white transition">
                Ver Mais Fotos
             </a>
          </div>
        </div>
      </section>

      {/* --- Contato --- */}
      <section id="contato" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row">
            
            {/* Informações de Contato */}
            <div className="bg-green-600 py-10 px-8 md:w-5/12 text-white flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-bold mb-6">Fale Comigo</h3>
                <p className="text-green-100 mb-8">
                  Preencha o formulário e entrarei em contato o mais rápido possível para agendarmos uma visita.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <Phone className="mr-4 mt-1" size={20} />
                    <div>
                      <p className="text-xs text-green-200 uppercase font-bold tracking-wider">Telefone / WhatsApp</p>
                      <p className="text-lg font-bold hover:text-green-100">(22) 99847-9003</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <Mail className="mr-4 mt-1" size={20} />
                    <div>
                      <p className="text-xs text-green-200 uppercase font-bold tracking-wider">Email</p>
                      <p className="text-sm font-medium hover:text-green-100 break-all">{corretora.email}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <MapPin className="mr-4 mt-1" size={20} />
                    <div>
                      <p className="text-xs text-green-200 uppercase font-bold tracking-wider">Atuação</p>
                      <p className="text-lg font-medium">Macaé e Região - RJ</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-10 flex space-x-4">
                {/* Ícone do Instagram ATUALIZADO */}
                <a 
                  href={corretora.instagramLink} 
                  target="_blank" 
                  rel="noreferrer"
                  className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition"
                  title="Siga no Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>

            {/* Formulário */}
            <div className="py-10 px-8 md:w-7/12 bg-white">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Cadastro de Interesse</h3>
              <form onSubmit={handleFormSubmit} className="space-y-4">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-1">Nome Completo</label>
                  <input 
                    type="text" 
                    id="nome" 
                    required 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition" 
                    placeholder="Seu nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div>
                  <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-1">Telefone / WhatsApp</label>
                  <input 
                    type="tel" 
                    id="telefone" 
                    required 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition" 
                    placeholder="(22) 99999-9999" 
                    value={formData.telefone}
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email (Opcional)</label>
                  <input 
                    type="email" 
                    id="email" 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition" 
                    placeholder="seu@email.com" 
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <label htmlFor="interesse" className="block text-sm font-medium text-gray-700 mb-1">Interesse</label>
                  <select 
                    id="interesse" 
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition"
                    value={formData.interesse}
                    onChange={handleInputChange}
                  >
                    <option>Quero comprar meu 1º imóvel</option>
                    <option>Quero investir</option>
                    <option>Quero saber mais sobre financiamento</option>
                  </select>
                </div>

                <button 
                  type="submit" 
                  className="w-full py-4 rounded-lg font-bold text-white shadow-md transition duration-300 bg-green-700 hover:bg-green-800"
                >
                  Solicitar Contato no WhatsApp
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* --- Footer --- */}
      <footer className="bg-gray-900 text-gray-400 py-8 border-t border-gray-800 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0 text-center md:text-left">
            <h4 className="text-white text-lg font-bold">Elisangela Barcellos</h4>
            <p>Corretora de Imóveis - CRECI {corretora.creci}</p>
          </div>
          <div className="text-center md:text-right text-sm">
            <p>&copy; {new Date().getFullYear()} Todos os direitos reservados.</p>
            <p>Especialista MRV Marbelle - Macaé/RJ</p>
          </div>
        </div>
      </footer>

      {/* Botão Flutuante do WhatsApp */}
      <a 
        href={corretora.whatsappLink}
        onClick={trackWhatsAppClick} // DISPARO AQUI TAMBÉM
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 transition-all z-50 animate-bounce-slow"
        title="Falar no WhatsApp"
      >
        <MessageSquare size={32} fill="white" />
      </a>

    </div>
  );
};

export default App;